import { render, staticRenderFns } from "./DeviceLayout.vue?vue&type=template&id=24f8dc48&scoped=true&"
import script from "./DeviceLayout.vue?vue&type=script&lang=ts&"
export * from "./DeviceLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceLayout.vue?vue&type=style&index=0&id=24f8dc48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f8dc48",
  null
  
)

export default component.exports